
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding/[[...step]]",
      function () {
        return require("private-next-pages/onboarding/[[...step]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onboarding/[[...step]]"])
      });
    }
  